import styled from '@emotion/styled';

export const ScrollableUnorderedList = styled.ul<{ maxHeight: number }>((props) => ({
  maxHeight: props.maxHeight,
  overflowY: 'auto',
}));
